import { FiChevronDown, FiEdit3 } from "react-icons/fi";
import { Heading, Subheading } from "../OptionFont/Functions";
import { usePersistentLayoutDisclosure } from "./LayoutDisclosureContext";
import DisclosureMotion from "./DisclosureMotion";
import "./HeadingDisclosure.css";

export default function HeadingDisclosure({
  heading = "",
  subheading = "",
  onChange,
  onFocusOut,
}) {
  const [isExpanded, setIsExpanded] =
    usePersistentLayoutDisclosure("heading");

  return (
    <section className="sx-heading-disclosure">
      <button
        type="button"
        className={`sx-heading-disclosure__trigger${
          isExpanded ? " sx-heading-disclosure__trigger--open" : ""
        }`}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((expanded) => !expanded)}
      >
        <span className="sx-heading-disclosure__title">
          <FiEdit3
            className="sx-heading-disclosure__icon"
            aria-hidden="true"
          />
          <span>Edit Heading</span>
        </span>
        <FiChevronDown
          aria-hidden="true"
          className={`sx-heading-disclosure__chevron${
            isExpanded ? " sx-heading-disclosure__chevron--open" : ""
          }`}
        />
      </button>

      <DisclosureMotion
        expanded={isExpanded}
        contentClassName="sx-heading-disclosure__fields"
        role="region"
        ariaLabel="Heading and Sub-Heading fields"
      >
        <label className="sx-heading-disclosure__field">
          <span className="sx-heading-disclosure__label">Heading</span>
          <span className="sx-heading-disclosure__input">
            <Heading
              onChange={(value) => onChange("heading", value)}
              value={heading}
              onFocusOut={onFocusOut}
            />
          </span>
        </label>

        <label className="sx-heading-disclosure__field">
          <span className="sx-heading-disclosure__label">Sub-Heading</span>
          <span className="sx-heading-disclosure__input">
            <Subheading
              onChange={(value) => onChange("subheading", value)}
              value={subheading}
              onFocusOut={onFocusOut}
            />
          </span>
        </label>
      </DisclosureMotion>
    </section>
  );
}
